import axios from "./_axios";
import { API } from "./apiEndPoints";

// ask OPENAI
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/askOpenAi
export const askOpenai = (data) => {
  let result = axios()({
    method: "post",
    url: `${API.COMMON_V1}openai/`,
    data: data,
  });
  return result;
};
